<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";
import TermsOfServices from "../../../app/programs/portal/signup/TermsOfServices.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();
</script>

<template>
    <div class="divide-y">
        <div class="pb-6 space-y-3">
            <div class="space-y-1">
                <h3 class="text-base font-medium text-gray-900">Terms of Use</h3>
                <p class="text-sm text-gray-500">Add your partner program terms.</p>
            </div>
            <terms-of-services
                :tos-url="portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_url"
                @update:tos-url="portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_url = $event"
                :tos-save="!!portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_saved_locally"
                @update:tos-save="portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_saved_locally = $event"
                :tos-text="portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_text"
                @update:tos-text="portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_text = $event"
            >
            </terms-of-services>
        </div>

        <div class="py-3 space-y-3">
            <div class="space-y-1">
                <h3 class="text-base font-medium text-gray-900">Marketing consent</h3>
                <p class="text-sm text-gray-500">Collect marketing permissions from your partners.</p>
            </div>
            <text-field
                label="Text"
                name="portal_signup_marketing_consent_text"
                placeholder="E.g. I'd like to receive updates regarding my affiliate account"
                type="text"
                v-model="portalContentAndDesignStore.signupPageSettings.signup.marketing_consent"
            >
                <template #note>
                    Once text is entered, a checkbox will appear on your signup form.
                </template>
            </text-field>
        </div>
    </div>
</template>
